module.exports = __webpack_public_path__ + "img/neutral.f95ba376.png";